import { lazyRouteComponent } from "@tanstack/react-router";
import { BellRing } from "lucide-react";

import type { PageDef } from "@/app/registry";

import { AlertsBadge } from "./AlertBell";

/** ?tab=mine (History is the default); the old ?tab=settings goes to Account → Notifications. */
function parseAlertsSearch(s: Record<string, unknown>): {
  tab?: "history" | "mine" | "settings";
} {
  const t = s.tab;
  return t === "mine" || t === "settings" || t === "history" ? { tab: t } : {};
}

export const pages: PageDef[] = [
  {
    path: "/app/alerts",
    title: "Alerts",
    component: lazyRouteComponent(() => import("./AlertsPage"), "AlertsPage"),
    validateSearch: parseAlertsSearch,
    nav: {
      label: "Alerts",
      icon: BellRing,
      group: "Markets",
      order: 91,
      badge: AlertsBadge,
    },
  },
];
